"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uncontrollable = require("uncontrollable");

var _GenomeBrowsersDropdown = _interopRequireDefault(require("./controls/GenomeBrowsersDropdown.js"));

var _OrderingsDropdown = _interopRequireDefault(require("./controls/OrderingsDropdown.js"));

var _DownloadButton = _interopRequireDefault(require("./controls/download-button/DownloadButton.js"));

var _FiltersButton = _interopRequireDefault(require("./controls/filter/FiltersButton.js"));

var _heatmapCellTooltipFormatter = _interopRequireDefault(require("./formatters/heatmapCellTooltipFormatter.js"));

var _axesFormatters = _interopRequireDefault(require("./formatters/axesFormatters.js"));

var _Main = require("./heatmap-legend/Main.js");

var _CoexpressionOption = _interopRequireDefault(require("./coexpression/CoexpressionOption.js"));

var _Events = _interopRequireDefault(require("./Events.js"));

var _Manipulators = require("./Manipulators.js");

var _reactDebounceRender = _interopRequireDefault(require("react-debounce-render"));

var _anatomogram = _interopRequireDefault(require("@ebi-gene-expression-group/anatomogram"));

var _HeatmapCanvas2 = _interopRequireDefault(require("../show/HeatmapCanvas.js"));

var _urijs = _interopRequireDefault(require("urijs"));

var _chartDataPropTypes = require("../manipulate/chartDataPropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Anatomogram = (0, _reactDebounceRender["default"])(_anatomogram["default"], 50);
var HeatmapCanvas = (0, _reactDebounceRender["default"])(_HeatmapCanvas2["default"], 50);

var renderGenomeBrowsersDropdown = function renderGenomeBrowsersDropdown(_ref) {
  var allGenomeBrowsers = _ref.allGenomeBrowsers,
      currentGenomeBrowser = _ref.currentGenomeBrowser,
      onChangeCurrentGenomeBrowser = _ref.onChangeCurrentGenomeBrowser;
  return allGenomeBrowsers.length ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "inline-block",
      padding: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_GenomeBrowsersDropdown["default"], {
    genomeBrowsers: allGenomeBrowsers,
    selected: currentGenomeBrowser,
    onSelect: onChangeCurrentGenomeBrowser
  })) : null;
};

var renderOrderings = function renderOrderings(_ref2) {
  var heatmapData = _ref2.heatmapData,
      heatmapConfig = _ref2.heatmapConfig,
      allOrderings = _ref2.allOrderings,
      currentOrdering = _ref2.currentOrdering,
      onChangeCurrentOrdering = _ref2.onChangeCurrentOrdering,
      currentZoom = _ref2.currentZoom;
  var orderingCanChangeRowOrder = heatmapData.yAxisCategories.length > 1;
  return heatmapConfig.isMultiExperiment ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "inline-block",
      padding: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_OrderingsDropdown["default"], {
    allOptions: allOrderings.map(function (o) {
      return o.name;
    }),
    currentOption: currentOrdering.name,
    onChangeCurrentOption: function onChangeCurrentOption(name) {
      return onChangeCurrentOrdering(allOrderings.find(function (o) {
        return o.name === name;
      }));
    },
    title: currentZoom ? "Reset zoom to enable sorting options" : "",
    disabled: currentZoom || !orderingCanChangeRowOrder
  })) : null;
};

var renderDownloadButton = function renderDownloadButton(_ref3, heatmapData) {
  var _ref3$heatmapConfig = _ref3.heatmapConfig,
      shortDescription = _ref3$heatmapConfig.shortDescription,
      description = _ref3$heatmapConfig.description,
      disclaimer = _ref3$heatmapConfig.disclaimer,
      experiment = _ref3$heatmapConfig.experiment,
      atlasUrl = _ref3$heatmapConfig.atlasUrl,
      outProxy = _ref3$heatmapConfig.outProxy,
      currentOrdering = _ref3.currentOrdering,
      allNumCoexpressions = _ref3.allNumCoexpressions,
      currentNumCoexpressions = _ref3.currentNumCoexpressions;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "inline-block",
      padding: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_DownloadButton["default"], {
    disclaimer: disclaimer,
    currentlyShownContent: {
      name: shortDescription || "download",
      descriptionLines: description.concat(experiment ? [] : ["Ordering: ".concat(currentOrdering.name)], allNumCoexpressions && currentNumCoexpressions ? ["Including ".concat(currentNumCoexpressions, " genes with similar expression pattern")] : [], experiment ? ["Results as shown on page"] : []),
      heatmapData: heatmapData
    },
    fullDatasetUrl: experiment ? outProxy + (0, _urijs["default"])(experiment.urls.download, atlasUrl).toString() : ""
  }));
};

var renderFiltersButton = function renderFiltersButton(_ref4) {
  var heatmapConfig = _ref4.heatmapConfig,
      _ref4$columnGroups = _ref4.columnGroups,
      groupingNames = _ref4$columnGroups.groupingNames,
      categories = _ref4$columnGroups.categories,
      categoryCheckboxes = _ref4$columnGroups.categoryCheckboxes,
      currentZoom = _ref4.currentZoom,
      allGroupedColumns = _ref4.allGroupedColumns,
      currentGroupedColumns = _ref4.currentGroupedColumns,
      onChangeCurrentGroupedColumns = _ref4.onChangeCurrentGroupedColumns;
  return heatmapConfig.isMultiExperiment && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "inline-block",
      padding: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_FiltersButton["default"], {
    categories: categories,
    categoryCheckboxes: categoryCheckboxes,
    allValues: allGroupedColumns,
    currentValues: currentGroupedColumns,
    disabled: currentZoom,
    onChangeCurrentValues: onChangeCurrentGroupedColumns,
    tabNames: groupingNames
  }));
};

var renderCoexpressionOption = function renderCoexpressionOption(_ref5) {
  var heatmapConfig = _ref5.heatmapConfig,
      heatmapData = _ref5.heatmapData,
      allNumCoexpressions = _ref5.allNumCoexpressions,
      currentNumCoexpressions = _ref5.currentNumCoexpressions,
      onChangeCurrentNumCoexpressions = _ref5.onChangeCurrentNumCoexpressions;
  return heatmapConfig.coexpressionsAvailable && !heatmapConfig.isWidget ? /*#__PURE__*/_react["default"].createElement(_CoexpressionOption["default"], {
    geneName: heatmapData.yAxisCategories[0].label,
    numCoexpressionsVisible: currentNumCoexpressions,
    numCoexpressionsAvailable: allNumCoexpressions,
    showCoexpressionsCallback: onChangeCurrentNumCoexpressions
  }) : null;
};

var renderGenomeBrowserHint = function renderGenomeBrowserHint(_ref6) {
  var currentGenomeBrowser = _ref6.currentGenomeBrowser;
  return currentGenomeBrowser && /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      clear: "both",
      "float": "right",
      fontSize: "small",
      margin: "0",
      display: " block"
    }
  }, "Click on a cell to open the selected genome browser with attached tracks if available");
};

var CanvasLegend = function CanvasLegend(_ref7) {
  var heatmapData = _ref7.heatmapData,
      heatmapConfig = _ref7.heatmapConfig,
      colourAxis = _ref7.colourAxis,
      children = _ref7.children;
  return heatmapConfig.isMultiExperiment ? /*#__PURE__*/_react["default"].createElement("div", null, children, /*#__PURE__*/_react["default"].createElement(_Main.DataSeriesLegend, {
    dataSeries: heatmapData.dataSeries
  })) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Main.GradientLegend, {
    heatmapConfig: heatmapConfig,
    colourAxis: colourAxis
  }), children);
};

CanvasLegend.propTypes = {
  heatmapConfig: _chartDataPropTypes.heatmapConfigPropTypes.isRequired,
  heatmapData: _chartDataPropTypes.heatmapDataPropTypes.isRequired,
  colourAxis: _chartDataPropTypes.colourAxisPropTypes
};

var heatmapExtraArgs = function heatmapExtraArgs(_ref8) {
  var heatmapData = _ref8.heatmapData,
      onOntologyIdIsUnderFocus = _ref8.onOntologyIdIsUnderFocus,
      heatmapConfig = _ref8.heatmapConfig,
      onChangeCurrentZoom = _ref8.onChangeCurrentZoom,
      ontologyIdsToHighlight = _ref8.ontologyIdsToHighlight;
  return _objectSpread({
    noDataCellsColour: heatmapConfig.isMultiExperiment ? "white" : "rgb(235, 235, 235)",
    ontologyIdsToHighlight: ontologyIdsToHighlight,
    onZoom: onChangeCurrentZoom,
    events: (0, _Events["default"])({
      heatmapData: heatmapData,
      onSelectOntologyIds: onOntologyIdIsUnderFocus,
      heatmapConfig: heatmapConfig
    }),
    cellTooltipFormatter: (0, _heatmapCellTooltipFormatter["default"])(heatmapConfig)
  }, (0, _axesFormatters["default"])(heatmapConfig));
};

var heatmapDataToPresent = function heatmapDataToPresent(_ref9) {
  var heatmapConfig = _ref9.heatmapConfig,
      heatmapData = _ref9.heatmapData,
      currentNumCoexpressions = _ref9.currentNumCoexpressions,
      currentGroupedColumns = _ref9.currentGroupedColumns,
      currentOrdering = _ref9.currentOrdering;
  return (0, _Manipulators.manipulate)({
    keepSeries: function keepSeries() {
      return true;
    },
    keepRow: heatmapConfig.coexpressionsAvailable ? function (rowHeader) {
      return heatmapData.yAxisCategories.slice(0, currentNumCoexpressions + 1).map(function (yAxisCategory) {
        return yAxisCategory.label;
      }).includes(rowHeader.label);
    } : function () {
      return true;
    },
    keepColumn: function keepColumn(columnHeader) {
      return currentGroupedColumns.some(function (c) {
        return c.value === columnHeader.label;
      });
    },
    ordering: currentOrdering,
    allowEmptyColumns: Boolean(heatmapConfig.experiment)
  }, heatmapData);
};

var renderHeatmapCanvasWithSelectedDataSlice = function renderHeatmapCanvasWithSelectedDataSlice(_args, heatmapDataToPresent, withAnatomogram) {
  var args = _objectSpread(_objectSpread({}, _args), {}, {
    heatmapData: heatmapDataToPresent
  });

  return /*#__PURE__*/_react["default"].createElement(CanvasLegend, args, /*#__PURE__*/_react["default"].createElement(HeatmapCanvas, _extends({}, heatmapExtraArgs(args), {
    heatmapData: heatmapDataToPresent,
    withAnatomogram: withAnatomogram,
    currentGenomeBrowser: _args.currentGenomeBrowser
  })));
};

var renderAnatomogramControlsAndCanvas = function renderAnatomogramControlsAndCanvas(args, heatmapDataToPresent, anatomogramArgs) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      clear: "both",
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      clear: "both"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "inline-block",
      width: "30%"
    }
  }, args.heatmapConfig.introductoryMessage), args.heatmapConfig.showControlMenu && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "inline-block",
      width: "70%",
      textAlign: "right"
    }
  }, renderGenomeBrowsersDropdown(args), renderOrderings(args), renderFiltersButton(args), renderDownloadButton(args, heatmapDataToPresent))), renderGenomeBrowserHint(args), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      clear: "both"
    }
  }, !!anatomogramArgs && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "17%",
      marginRight: "3%",
      display: "inline-block",
      verticalAlign: "top"
    }
  }, /*#__PURE__*/_react["default"].createElement(Anatomogram, anatomogramArgs)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: !anatomogramArgs ? "100%" : "80%",
      display: "inline-block",
      verticalAlign: "top"
    }
  }, renderHeatmapCanvasWithSelectedDataSlice(args, heatmapDataToPresent, !!anatomogramArgs), renderCoexpressionOption(args))));
};

var _HeatmapWithControls = /*#__PURE__*/function (_React$Component) {
  _inherits(_HeatmapWithControls, _React$Component);

  var _super = _createSuper(_HeatmapWithControls);

  function _HeatmapWithControls(props) {
    var _this;

    _classCallCheck(this, _HeatmapWithControls);

    _this = _super.call(this, props);
    _this.state = {
      highlightIds: [],
      highlightColumns: []
    };
    _this.onOntologyIdIsUnderFocus = _this._onOntologyIdIsUnderFocus.bind(_assertThisInitialized(_this));
    _this.onTissueIdIsUnderFocus = _this._onTissueIdIsUnderFocus.bind(_assertThisInitialized(_this));
    _this.onTissueIdIsNotUnderFocus = _this._onTissueIdIsNotUnderFocus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(_HeatmapWithControls, [{
    key: "_onOntologyIdIsUnderFocus",
    value: function _onOntologyIdIsUnderFocus(ids) {
      this.setState({
        highlightIds: ids
      });
    }
  }, {
    key: "_onTissueIdIsUnderFocus",
    value: function _onTissueIdIsUnderFocus(ids) {
      this.setState({
        highlightColumns: ids
      });
    }
  }, {
    key: "_onTissueIdIsNotUnderFocus",
    value: function _onTissueIdIsNotUnderFocus() {
      this.setState({
        highlightColumns: []
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var args = Object.assign({}, this.state, this.props, {
        onOntologyIdIsUnderFocus: this.onOntologyIdIsUnderFocus,
        ontologyIdsToHighlight: this.state.highlightColumns
      });
      var heatmapData = heatmapDataToPresent(args);
      var anatomogramArgs = this.props.anatomogramConfig.show ? {
        atlasUrl: process.env.NODE_ENV === "development" ? "" : // In development mode we load assets from Webpack’s output.publicPath
        this.props.anatomogramConfig.atlasUrl,
        species: this.props.anatomogramConfig.anatomogramData.species,
        showIds: heatmapData.xAxisCategories.map(function (e) {
          return e.id;
        }),
        highlightIds: heatmapData.xAxisCategories.map(function (e) {
          return e.id;
        }).filter(function (id) {
          return _this2.state.highlightIds.includes(id);
        }),
        selectIds: [],
        onMouseOver: this.onTissueIdIsUnderFocus,
        onMouseOut: this.onTissueIdIsNotUnderFocus
      } : null;
      return renderAnatomogramControlsAndCanvas(args, heatmapData, anatomogramArgs);
    }
  }]);

  return _HeatmapWithControls;
}(_react["default"].Component);

_HeatmapWithControls.propTypes = {
  allGenomeBrowsers: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  currentGenomeBrowser: _propTypes["default"].string.isRequired,
  onChangeCurrentGenomeBrowser: _propTypes["default"].func.isRequired,
  allOrderings: _propTypes["default"].arrayOf(_chartDataPropTypes.orderingPropTypes),
  currentOrdering: _chartDataPropTypes.orderingPropTypes,
  onChangeCurrentOrdering: _propTypes["default"].func.isRequired,
  allGroupedColumns: _propTypes["default"].arrayOf(_chartDataPropTypes.groupedColumnPropTypes).isRequired,
  currentGroupedColumns: _propTypes["default"].arrayOf(_chartDataPropTypes.groupedColumnPropTypes).isRequired,
  onChangeCurrentGroupedColumns: _propTypes["default"].func.isRequired,
  allNumCoexpressions: _propTypes["default"].number.isRequired,
  currentNumCoexpressions: _propTypes["default"].number.isRequired,
  onChangeCurrentNumCoexpressions: _propTypes["default"].func.isRequired,
  currentZoom: _propTypes["default"].bool.isRequired,
  onChangeCurrentZoom: _propTypes["default"].func.isRequired,
  //and also props that aren't controls, in particular:
  heatmapConfig: _chartDataPropTypes.heatmapConfigPropTypes.isRequired,
  heatmapData: _chartDataPropTypes.heatmapDataPropTypes.isRequired,
  colourAxis: _chartDataPropTypes.colourAxisPropTypes,
  // Only available in experiment heatmap
  columnGroups: _chartDataPropTypes.columnGroupsPropTypes
};
var HeatmapWithControls = (0, _uncontrollable.uncontrollable)(_HeatmapWithControls, {
  currentGenomeBrowser: "onChangeCurrentGenomeBrowser",
  currentOrdering: "onChangeCurrentOrdering",
  currentGroupedColumns: "onChangeCurrentGroupedColumns",
  currentNumCoexpressions: "onChangeCurrentNumCoexpressions",
  currentZoom: "onChangeCurrentZoom"
});

var HeatmapWithControlsContainer = function HeatmapWithControlsContainer(props) {
  var yAxisCategories = props.heatmapData.yAxisCategories,
      orderings = props.orderings,
      heatmapConfig = props.heatmapConfig,
      groupedColumns = props.columnGroups.data;
  var defaultCurrentGenomeBrowser = Array.isArray(heatmapConfig.genomeBrowsers) && heatmapConfig.genomeBrowsers[0] ? heatmapConfig.genomeBrowsers[0].replace(/\s+/g, "").toLowerCase() : null;
  return /*#__PURE__*/_react["default"].createElement(HeatmapWithControls, _extends({}, props, {
    allGenomeBrowsers: heatmapConfig.genomeBrowsers,
    allOrderings: orderings,
    allGroupedColumns: groupedColumns,
    allNumCoexpressions: heatmapConfig.coexpressionsAvailable ? yAxisCategories.length - 1 : 0,
    defaultCurrentGenomeBrowser: defaultCurrentGenomeBrowser,
    defaultCurrentOrdering: orderings[0],
    defaultCurrentGroupedColumns: groupedColumns,
    defaultCurrentNumCoexpressions: 0,
    defaultCurrentZoom: false
  }));
};

HeatmapWithControlsContainer.propTypes = {
  heatmapConfig: _chartDataPropTypes.heatmapConfigPropTypes.isRequired,
  heatmapData: _chartDataPropTypes.heatmapDataPropTypes.isRequired,
  orderings: _propTypes["default"].arrayOf(_chartDataPropTypes.orderingPropTypes)
};
var _default = HeatmapWithControlsContainer;
exports["default"] = _default;